import React from 'react';
import PillarMaterialsSection from '../portal/PillarMaterialsSection';

/**
 * Portal Finance ▸ Materials tab. Sections and templates are edited from
 * CRM → Templates → Finance Materials (templatesStructures/finance +
 * templatesCollections docs with pillar 'Finance').
 */
const FinanceMaterialsTab = () => (
  <PillarMaterialsSection
    standalone
    pillar="Finance"
    structureId="finance"
    idPrefix="finance-material"
    emptyText="Finance materials are on the way — check back soon."
  />
);

export default FinanceMaterialsTab;
